const baseURL = "https://dev.mybranzapi.link";
// const baseURL = "https://test.mybranzapi.link";

const apiUrls = {
  baseURL,
  postMedia: "media/single",
  media: "media/%s",
  brand: "/interests/brand",
  brandList: "/interests",
  notification: "/interests/notification",
  createReward: "/interests/rewardItem",
  getRewardList: "/interests/rewardItem/list",
  rewardItem: "/interests/rewardItem/%s",
};

export { apiUrls };
